/*************************************************/
/* CALENDAR                                      */
/*************************************************/

export function calendar() {
    const init = () => {
            var calendarEl = document.getElementById('calendar');

            if (!calendarEl) {
                return; // Stop the script execution
            }

            var eventsData = JSON.parse(calendarEl.getAttribute('data-events'));

            const largeScreenToolbar = {
                left: 'prev,next today',
                center: 'title',
                right: 'dayGridMonth,timeGridWeek,timeGridDay'
            };
    
            const smallScreenToolbar = {
                left: 'prev,next',
                center: '',
                right: 'title'
            };
    
            // Function to dynamically set the toolbar based on screen size
            const updateHeaderToolbar = () => {
                if (window.innerWidth < 768) {
                    calendar.setOption('headerToolbar', smallScreenToolbar); // Use smaller toolbar on mobile
                    calendar.changeView('dayGridDay'); // Change view for smaller screens
                } else {
                    calendar.setOption('headerToolbar', largeScreenToolbar); // Use full toolbar on larger screens
                    calendar.changeView('dayGridMonth'); // Use full month view for larger screens
                }
            };


            var calendar = new FullCalendar.Calendar(calendarEl, {
                initialView: 'dayGridMonth',
                events: eventsData,
                eventTimeFormat: { 
                    hour: '2-digit',
                    minute: '2-digit',
                    hour12: false // Set to false to use 24-hour format and remove AM/PM
                  },
                  headerToolbar: largeScreenToolbar,
                nowIndicator: true
            });
          
            window.addEventListener('resize', updateHeaderToolbar);

            updateHeaderToolbar();

            calendar.render();
          
    };

    init();
}